// eslint-disable-next-line
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import {
  Box,
  Button,
  Flex,
  HStack,
  Radio,
  RadioGroup,
  Tag,
  Text,
  VStack,
} from '@chakra-ui/react';
import L70 from '../assets/CDC.png'
import L50 from '../assets/CDC.png'
import L30 from '../assets/CDC.png'
import L20 from '../assets/CDC.png'
import L10 from '../assets/CDC.png'
import L5 from '../assets/CDC.png'
import L3 from '../assets/CDC.png'
import L1 from '../assets/CDC.png'
import circuit from '../assets/CDC.png'

interface Data {
  id: number;
  address: string;
  value: string;
  rank:number;

}

export const LRanking = () => {
  const [data, setData] = useState<Data[]>([]);
  const [filteredData, setFilteredData] = useState<Data[]>([]);
  const [value, setValue] = React.useState('0xf96ec7C11D311920833753FAB9b174B6FD53517E')

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(
        'https://cronos.org/explorer/api?module=token&action=getTokenHolders&contractaddress='+value+'&page=1&offset=500'
      );
      const sortedData = result.data.result.map((item: any) => ({
        id: item.id,
        address: item.address,
        value: item.value,
        rank:item.rank,
      }))
      .sort((a:Data, b:Data) => Number(b.value) - Number(a.value));
      const editedData = sortedData.map((item:Data, index:number) => ({
        ...item,
        rank: index + 1
      }));
      
      setData(editedData);
      setFilteredData(editedData);
    };

    fetchData();
  }, [value]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value.trim().toLowerCase();
    const filtered = data.filter(
      (item) => item.address.toLowerCase().includes(value) || item.value.toLowerCase().includes(value)
    );
    setFilteredData(filtered);
  };

  const handleClear = () => {
    setFilteredData(data);
  };

  
  return (
    <Box fontSize="1.2vw" className="ranking" display="flex" flexDirection="column" alignItems="center">
    
   

 
  </Box>
  );
};
